export default __webpack_public_path__ + "static/media/blog.52102140.png";